import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
/* 
  HK为港台
  KR为韩国  
  后续加其他地区务在注释这里写清楚,均为大写

*/
// 默认港台
// 韩国域名列表
let KRList = [
  "https://rechargekr.shhws.cn",
  "https://rgkr-xjjdcj.shhws.cn",
]
let language = "HK";
if (process.env.NODE_ENV === "development") {
  let region = location.href.split("?")[1]?.split("=")[1];
  language = region ? region.toUpperCase() : "HK";
} else {
  let url = location.href;
  if (url.includes("https://recharge.shhws.cn")) {
    language = "HK";
  }
  if (KRList.find(item => {
    return url.includes(item)
  })) {
    language = "KR";
  }
}

console.log(language)

export default new Vuex.Store({
  state: {
    language,
  },
  mutations: {},
  actions: {},
  modules: {},
});
